import DarkModeIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeIcon from "@mui/icons-material/LightModeOutlined";
import React, { useCallback, useContext, useState } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchCurrentUserDetails } from "../../../actions";
import { updateUserDetails } from "../../../api";
import { ThemeContext } from "../../../context";

export const DarkLightToggle = (): JSX.Element => {
  const dispatch = useDispatch();
  const userDetails = useSelector((state: RootStateOrAny) => state.user.details);
  const { setTheme } = useContext(ThemeContext);
  const wrapperClass = "input_field";
  const isDark = Boolean(userDetails.dark_mode);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleThemeChange = useCallback(() => {
    // Only the one field this control can ever change - not the whole Redux userDetails object
    // (groups/views included), which used to get resent unchanged on every single toggle click.
    if (isUpdating) return;
    setIsUpdating(true);
    updateUserDetails(userDetails.email, { dark_mode: !userDetails.dark_mode })
      .then((response) => {
        if (response && !("error" in response)) {
          response.dark_mode ? setTheme("dark") : setTheme("light");
          dispatch(fetchCurrentUserDetails());
          toast.success("Theme updated successfully");
        } else {
          toast.error("Failed to update theme, please try again later");
        }
      })
      .finally(() => setIsUpdating(false));
  }, [userDetails, isUpdating]);

  return (
    <div className={wrapperClass} style={{ marginBottom: "0" }}>
      <div className="field theme-button">
        <button
          type="button"
          role="switch"
          aria-checked={isDark}
          aria-label="Toggle dark mode"
          className={`theme_toggle ${isDark ? "theme_toggle--dark" : ""}`}
          onClick={handleThemeChange}
          data-test-id="theme-toggle"
        >
          <span className="theme_toggle_thumb" />
          <LightModeIcon className={`theme_toggle_icon ${!isDark ? "theme_toggle_icon--active" : ""}`} />
          <DarkModeIcon className={`theme_toggle_icon ${isDark ? "theme_toggle_icon--active" : ""}`} />
        </button>
      </div>
    </div>
  );
};
